"use client";
import { useCallback, useEffect, useRef, useState } from "react";
import { isFibblEnabled } from "@components/fibbl/constants";

export type UseFibblProps = {
    sku: string;
};

export interface UseFibblReturnType {
    isFibblEnabled: boolean;
    isFibblReady: boolean;
    isVtoActive: boolean;
    sku: string;
    layerRef: React.RefObject<HTMLElement | null>;
    openVto: () => void;
    closeVto: () => void;
}

export const useFibbl = ({ sku }: UseFibblProps): UseFibblReturnType => {
    const [isFibblReady, setIsFibblReady] = useState(false);
    const [isVtoActive, setIsVtoActive] = useState(false);

    const layerRef = useRef<HTMLElement>(null);

    useEffect(() => {
        setIsFibblReady(false);
        setIsVtoActive(false);
    }, [sku]);

    // Listen for fibbl-ready event on the web component
    useEffect(() => {
        const el = layerRef.current;
        if (!el) return;

        const handleReady = () => setIsFibblReady(true);
        el.addEventListener("fibbl-ready", handleReady);
        return () => el.removeEventListener("fibbl-ready", handleReady);
    }, [sku]);

    const openVto = useCallback(() => setIsVtoActive(true), []);
    const closeVto = useCallback(() => setIsVtoActive(false), []);

    return {
        isFibblEnabled,
        isFibblReady,
        isVtoActive,
        sku,
        layerRef,
        openVto,
        closeVto,
    };
};
